/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

export const loginSlice = createSlice({
  name: 'login',
  initialState: {
    accessToken: null,
    refreshToken: null,
    // userId: '',
    // userCd: '',
    // userName: '',
    // lclGov: null,
    // role: null,
    // place: null,
    // permission: '',
  },
  reducers: {
    login: (state, action) => {
      // state.keycloak = action.payload.keycloak;
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
      // state.userId = action.payload.userId;
      // state.userCd = action.payload.userCd;
      // state.userName = action.payload.userName;
      // state.lclGov = action.payload.lclGov;
      // state.role = action.payload.role;
      // state.place = action.payload.place;
      // state.permission = action.payload.permission;
    },
    // refresh: (state, action) => {
    //   state.accessToken = action.payload.accessToken;
    //   state.refreshToken = action.payload.refreshToken;
    // },
    logout: (state) => {
      state.accessToken = null;
      state.refreshToken = null;
      // // state.userId = null;
      // state.userId = '';
      // state.userCd = '';
      // state.userName = '';
      // state.lclGov = null;
      // state.role = null;
      // state.place = null;
      // state.permission = '';
    },
  },
});

export const { login, logout } = loginSlice.actions;
export const loginReducer = loginSlice.reducer;
